import { ref, onMounted, onUnmounted } from "vue";

export function useScrollPosition() {
  const scrollPosition = ref(0);

  const handleScroll = () => {
    scrollPosition.value = window.scrollY;
  };

  onMounted(() => {
    window.addEventListener("scroll", handleScroll);
  });

  onUnmounted(() => {
    window.removeEventListener("scroll", handleScroll);
  });

  return {
    scrollPosition,
  };
}
